export default __webpack_public_path__ + "static/media/phonepe.fef1950d.png";